import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

const initialState = {
  unitMeasures: [],
  companyRates: [],
  paymentOptions: [],
  subsidiariesOptions: [],
  clientInfo: undefined,
  activeVats: [],
  activeUnitMeasures: [],
  canExport: false,
  defaultUnitMeasureId: "",
};

interface SettingsStore {
  resetStore: () => void;
  unitMeasures: LabelValueType[];
  activeUnitMeasures: LabelValueType[];
  activeVats: ActiveVatsType[];
  subsidiariesOptions: SubsidiariesOption[];
  paymentOptions: LabelValueType[];
  companyRates: CompanyRatesType[];
  clientInfo: ClientInfoType | undefined;
  companyMainAddress: CompanyMainAddressType | undefined;
  bank: BankType | undefined;
  canExport: boolean;
  defaultUnitMeasureId: ID;
  setUnitMeasures: (unitMeasures: LabelValueType[]) => void;
  setCompanyRates: (companyRates: CompanyRatesType[]) => void;
  setPaymentOptions: (paymentOptions: LabelValueType[]) => void;
  setClientInfo: (clientInfo: ClientInfoType) => void;
  setCompanyMainAddress: (companyMainAddress: CompanyMainAddressType) => void;
  setActiveVats: (activeVats: ActiveVatsType[]) => void;
  setActiveUnitMeasures: (activeUnitMeasures: LabelValueType[]) => void;
  setCanExport: (canExport: boolean) => void;
  setDefaultUnitMeasureId: (defaultUnitMeasureId: ID) => void;
  setBank: (bank: BankType) => void;
  setSubsidiariesOptions: (subsidiariesOptions: SubsidiariesOption[]) => void;
}

const useSettingsStore: UseBoundStore<StoreApi<SettingsStore>> = createStore<SettingsStore>(
  (set: (fn: (draft: Record<string, any>) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    setUnitMeasures: (unitMeasures: LabelValueType[]) => {
      setStateHelper("unitMeasures", unitMeasures, set);
    },
    setDefaultUnitMeasureId: (defaultUnitMeasureId: ID) => {
      setStateHelper("defaultUnitMeasureId", defaultUnitMeasureId, set);
    },
    setBank: (bank: BankType) => {
      setStateHelper("bank", bank, set);
    },
    setPaymentOptions: (paymentOptions: LabelValueType[]) => {
      setStateHelper("paymentOptions", paymentOptions, set);
    },
    setCompanyRates: (companyRates: CompanyRatesType[]) => {
      setStateHelper("companyRates", companyRates, set);
    },
    setClientInfo: (clientInfo: ClientInfoType) => {
      setStateHelper("clientInfo", clientInfo, set);
    },
    setCompanyMainAddress: (companyMainAddress: CompanyMainAddressType) => {
      setStateHelper("companyMainAddress", companyMainAddress, set);
    },
    setActiveVats: (activeVats: ActiveVatsType[]) => {
      setStateHelper("activeVats", activeVats, set);
    },
    setActiveUnitMeasures: (activeUnitMeasures: LabelValueType[]) => {
      setStateHelper("activeUnitMeasures", activeUnitMeasures, set);
    },
    setSubsidiariesOptions: (subsidiariesOptions: SubsidiariesOption[]) => {
      setStateHelper("subsidiariesOptions", subsidiariesOptions, set);
    },
    setCanExport: (canExport: boolean) => {
      setStateHelper("canExport", canExport, set);
    },
  }),
);

export default useSettingsStore;
